import { PageProps, graphql } from 'gatsby'
import { StaticImage } from 'gatsby-plugin-image'
import { InfoCard } from 'component-library'
import Seo from '../components/seo'
import LinkComponent from '../components/LinkComponent/LinkComponent'
import DatasetsHero from '../components/DatasetsHero/DatasetsHero'

import homepageContent from '../../content/homepage'

const { metadata } = homepageContent

const HERO_BACKGROUND = `https://assets.cloud.pennylane.ai/pennylane_website/backgrounds/confetti_transparent.png`

const IndexPage = ({ data }: PageProps<Queries.AllDatasetCollectionsQuery>) => {
  const collectionCount = (data) => {
    return data.__typename === 'DATASETS_DatasetCollection' ? (
      <span className="bg-brand-blue-5 text-white h-8 w-8 flex rounded-full text-center border-grey-9 border">
        <span className="m-auto">{data.numFamilies}</span>
      </span>
    ) : (
      <></>
    )
  }

  const datasetTag = (typename: string) => {
    return typename == 'DATASETS_DatasetCollection' ? (
      <>
        <i className="bx bxs-folder" /> Dataset collection
      </>
    ) : (
      <>
        <i className="bx bxs-data" /> Dataset
      </>
    )
  }

  const datasetUrl = (typename: string, slug: string) => {
    return typename == 'DATASETS_DatasetCollection'
      ? `/collection/${slug}`
      : `/${slug}`
  }

  return (
    <>
      <StaticImage
        src={HERO_BACKGROUND}
        alt=""
        loading="eager"
        placeholder="none"
        quality={100}
        objectPosition="top left"
        className="absolute top-0 left-0 -z-10 right-auto"
      />
      <DatasetsHero />
      <section className="mx-auto container mb-20">
        <div className="grid md:grid-cols-3 lg:grid-cols-4 gap-6">
          {data?.datasets.datasetSummary?.map((collection, index) => (
            <LinkComponent
              key={`data-family-${collection.title}-${index}`}
              href={datasetUrl(collection.__typename, collection.slug)}
              testId="data-family-link"
            >
              <InfoCard
                tagsTopRight={collectionCount(collection)}
                tag={datasetTag(collection.__typename)}
                label={collection.title || ''}
                className="CategoryGroup__dataset"
                image={
                  !collection.previewImage ||
                  !collection.previewImage.includes('https://')
                    ? 'https://assets.cloud.pennylane.ai/datasets/generic/thumbnail/pennylane-datasets-thumbnail-generic.png'
                    : collection.previewImage
                }
              />
            </LinkComponent>
          ))}
        </div>
      </section>
    </>
  )
}

export default IndexPage

export const Head = () => {
  return (
    <Seo
      title={metadata.title}
      description={metadata.description}
      image={metadata.image}
    />
  )
}

export const pageQuery = graphql`
  query AllDatasetCollections {
    datasets {
      datasetSummary {
        __typename
        ... on DATASETS_DatasetCollection {
          slug
          title
          previewImage
          numFamilies
        }
        ... on DATASETS_DatasetFamily {
          slug
          title
          previewImage
        }
      }
    }
  }
`
